import { Center, Spinner } from "@givenwell/components";
import { createRouter } from "@tanstack/react-router";
import { ErrorComponent } from "./pages/+500";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  context: {
    conditionalTopBar: false,
  },
  notFoundMode: "fuzzy",
  defaultErrorComponent: ErrorComponent,
  defaultPendingComponent: () => (
    <Center css={{ flex: "1 0 0px" }}>
      <Spinner />
    </Center>
  ),
  defaultPreload: "intent",
  defaultPreloadDelay: 100,
  unmaskOnReload: true,
  scrollRestoration: true,
  scrollRestorationBehavior: "instant",
  getScrollRestorationKey(location) {
    return location.pathname;
  },
});

if (import.meta.env.PROD) {
  router.subscribe("onResolved", event => {
    if (event.pathChanged) {
      import("./utils/analytics")
        .then(module => {
          module.capturePageView(window.location.origin + event.toLocation.href);
        })
        .catch(console.error);
    }
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
